import clsx from 'clsx';
// react
import { NavLink } from 'react-router-dom';
// utils
import { LOGO_FULL_URL, LOGO_URL } from '@newo/constants';
// assets
import styles from '@/components/Logo/Logo.module.css';

interface LogoProps {
    variant?: 'full' | 'icon';
    className?: string;
}

const Logo = ({ className, variant = 'full' }: LogoProps) => {
    if (variant === 'full') {
        return (
            <NavLink className={clsx(styles.logo, className)} to="/">
                <img
                    alt="Newo AI"
                    height={24}
                    src={LOGO_FULL_URL}
                    width={116}
                />
            </NavLink>
        );
    }
    return (
        <NavLink className={clsx(styles.logo, className)} to="/">
            <img alt="Newo AI" height={24} src={LOGO_URL} width={26} />
        </NavLink>
    );
};

export default Logo;
